import {mapGenerator} from '../config/axios'

export const getAQI = (coords, timestamp, callback) => {
    return mapGenerator.get('/analytics/Barcelona/aqi',{
        params: {
            lat: coords[0],
            lng: coords[1],
            timestamp
        }
    })
        .then((response) => callback(response.data))
        .catch((err) => console.log(err))

}

export const getAQIHistory = (coords, callback) => {
    return mapGenerator.get('/analytics/aqiHistory', {
        params: {
            lat: coords[0],
            lng: coords[1]
        }
    })
        .then((response) => callback(response.data))
        .catch((err) => console.log(err))
}

export const deleteAllAQIHistory =(map)=>{
    return mapGenerator.delete('/analytics/aqi/' + map)
}



// WEBPACK FOOTER //
// ./src/requests/analytics.js